import React from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import DrawerComponent from "./Drawer";
import "./Navbar.css";

const StyledNav = styled(AppBar)(({ theme }) => ({
  padding: "10px 10px",
  // backgroundColor: '#ffffff22',
}));

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: "#0d2369",
  fontSize: "15px",
  fontWeight: "bold",
  margin: "auto",
  marginLeft: theme.spacing(5),
  borderBottom: "1px solid transparent",
  "&:hover": {
    color: "rgb(55,184,171)",
    fontSize: "15.5px",
  },
}));

const Logo = styled("img")({
  height: "40px",
});

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <StyledNav position="sticky">
      <CssBaseline />
      <Toolbar style={{ justifyContent: "space-between" }}>
        <StyledLink to="/">
          <Logo src="./images/SHIVA-OLD-LOGO2.png" alt="main-logo" />
        </StyledLink>
        {isMobile ? (
          <DrawerComponent />
        ) : (
          <div style={{ display: "flex" }}>
            <StyledLink to="/">HOME</StyledLink>
            <StyledLink to="/about">ABOUT US</StyledLink>
            
            <StyledLink to="/institutions">INSTITUTIONS</StyledLink>
            <StyledLink to="/vision">VISION</StyledLink>
            <StyledLink to="/gallery">GALLERY</StyledLink>
            <StyledLink to="/news">NEWS</StyledLink>
            <StyledLink to="/contact">CONTACT</StyledLink>
          </div>
        )}
      </Toolbar>
    </StyledNav>
  );
};

export default Navbar;
